import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `https://nashoof.sd.zain.com/NashoofAP_I/APIs/`
})

